var map = {
	"./comment-select1.png": "g1eS",
	"./comment-select2.png": "QG+q",
	"./comment-select3.png": "Q6Y1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0Sgz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comment ^\.\/comment\-select.*\.png$
// module id = 0Sgz
// module chunks = 1